// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HelpMenu-iconContainer-fMabx {\n  position: relative;\n}\n.HelpMenu-dotContainer-1xKe7 {\n  position: absolute;\n  right: -4px;\n  top: -2px;\n  pointer-events: none;\n}\n", ""]);
// Exports
exports.locals = {
	"iconContainer": "HelpMenu-iconContainer-fMabx",
	"dotContainer": "HelpMenu-dotContainer-1xKe7"
};
module.exports = exports;
